module.exports = __webpack_public_path__ + "static/media/skybox-4.bc7c6c79.hdr";